import validate from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/node_modules/nuxt/dist/pages/runtime/validate.js";
import auth_45global from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/middleware/auth.global.ts";
import page_45global from "/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/middleware/page.global.ts";
export const globalMiddleware = [
  validate,
  auth_45global,
  page_45global
]
export const namedMiddleware = {
  admin: () => import("/Users/silvan.muehlemann/PycharmProjects/pictureclub-lz100/middleware/admin.ts")
}